{
  "_comment": "[CI-LOCKED] เนื้อหาของไฟล์นี้ถูกล็อก ยินดีรับการสนับสนุน แต่การตรวจสอบความถูกต้องของการเปลี่ยนแปลงอาจล่าช้า",
  "ACCESS_KEY_ALT": "Alt Shift $1",
  "ACCESS_KEY_FOR_MAC_ALT": "Control Option $1",
  "ACTIVITY_BOT_SAID_ALT": "บอท $1 กล่าวว่า:",
  "ACTIVITY_STATUS_VOICE_TRANSCRIPT_AGENT_LABEL": "เอเจนต์",
  "ACTIVITY_YOU_SAID_ALT": "คุณพูดว่า:",
  "ACTIVITY_BOT_ATTACHED_ALT": "บอทแนบ:",
  "ACTIVITY_CODE_ALT": "ตัวอย่างโค้ด: $1",
  "ACTIVITY_CONTENT_CAUTION": "เนื้อหาที่สร้างโดย AI อาจไม่ถูกต้อง",
  "ACTIVITY_CODE_CAUTION": "โค้ดที่สร้างโดย AI ตรวจสอบและใช้ด้วยความระมัดระวัง",
  "ACTIVITY_ERROR_BOX_TITLE": "ข้อความแสดงข้อผิดพลาด",
  "ACTIVITY_INTERACTIVE_FOOTNOTE_ALT": "คลิกเพื่อโต้ตอบ",
  "ACTIVITY_INTERACTIVE_REASON_INTERACTIVE_CONTENT_ALT": "ข้อความเป็นแบบโต้ตอบ",
  "ACTIVITY_INTERACTIVE_REASON_LINK_ALT": "มีลิงก์อย่างน้อยหนึ่งลิงก์ในข้อความ",
  "ACTIVITY_INTERACTIVE_REASON_SEND_FAILED_ALT": "การส่งไม่สำเร็จ",
  "ACTIVITY_YOU_ATTACHED_ALT": "คุณแนบ:",
  "ACTIVITY_NUM_ATTACHMENTS_ONE_ALT": "สิ่งที่แนบ 1 รายการ",
  "ACTIVITY_NUM_ATTACHMENTS_FEW_ALT": "สิ่งที่แนบ $1 รายการ",
  "ACTIVITY_NUM_ATTACHMENTS_MANY_ALT": "สิ่งที่แนบ $1 รายการ",
  "ACTIVITY_NUM_ATTACHMENTS_OTHER_ALT": "สิ่งที่แนบ $1 รายการ",
  "ACTIVITY_NUM_ATTACHMENTS_TWO_ALT": "สิ่งที่แนบ $1 รายการ",
  "ACTIVITY_STATUS_SEND_FAILED_RETRY": "ส่งไม่สำเร็จ [ลองใหม่][RETRY]",
  "ACTIVITY_STATUS_SEND_STATUS_ALT_SENDING": "กำลังส่ง",
  "ACTIVITY_STATUS_SEND_STATUS_ALT_SENT_AT": "ส่งเมื่อ $1",
  "ACTIVITY_STATUS_TIMESTAMP_JUST_NOW": "ตอนนี้",
  "ACTIVITY_STATUS_TIMESTAMP_ONE_HOUR_AGO": "ชั่วโมงที่แล้ว",
  "ACTIVITY_STATUS_TIMESTAMP_ONE_MINUTE_AGO": "นาทีที่แล้ว",
  "ACTIVITY_STATUS_TIMESTAMP_TODAY": "วันนี้",
  "ACTIVITY_STATUS_TIMESTAMP_YESTERDAY": "เมื่อวานนี้",
  "ADAPTIVE_CARD_ERROR_BOX_TITLE_PARSE": "ข้อผิดพลาดในการแยกวิเคราะห์ Adaptive Card",
  "ADAPTIVE_CARD_ERROR_BOX_TITLE_RENDER": "ข้อผิดพลาดในการแสดงผล Adaptive Card",
  "ATTACHMENT_AUDIO": "คลิปเสียง",
  "ATTACHMENT_CARD": "การ์ด: $1 $2 $3",
  "ATTACHMENT_FILE": "ไฟล์: $1",
  "ATTACHMENT_IMAGE": "รูปภาพ",
  "ATTACHMENT_TEXT": "ข้อความ: $1",
  "ATTACHMENT_VIDEO": "คลิปวิดีโอ",
  "AVATAR_ALT": "รูปประจำตัว $1",
  "CAROUSEL_FLIPPER_NEXT_ALT": "ถัดไป",
  "CAROUSEL_FLIPPER_PREVIOUS_ALT": "ก่อนหน้า",
  "CITATION_MODEL_DIALOG_ALT": "การอ้างอิงถึงแหล่งที่มา",
  "CLOSE_BUTTON_ALT": "ปิด",
  "COLLAPSIBLE_GROUPING_TITLE": "กำลังคิด…",
  "COLLAPSIBLE_GROUPING_TITLE.comment": "สิ่งนี้จะแสดงขึ้นเมื่อบอทกำลังเขียนข้อความตอบกลับในกลุ่ม หากไม่มีบทคัดย่อ",
  "COLLAPSE_BUTTON_LESS": "แสดงน้อยลง",
  "COLLAPSE_BUTTON_LESS.comment": "นี่คือข้อความของปุ่มเครื่องหมายบั้งเพื่อยุบกลุ่มข้อความ เมื่อผู้ใช้คลิกที่ปุ่ม กลุ่มข้อความจะพับ",
  "COLLAPSE_BUTTON_MORE": "แสดงเพิ่มเติม",
  "COLLAPSE_BUTTON_MORE.comment": "นี่คือข้อความของปุ่มเครื่องหมายบั้งเพื่อขยายกลุ่มข้อความ เมื่อผู้ใช้คลิกที่ปุ่ม กลุ่มข้อความจะขยาย",
  "CONNECTIVITY_STATUS_ALT_CONNECTED": "เชื่อมต่อแล้ว",
  "CONNECTIVITY_STATUS_ALT_CONNECTING": "กำลังเชื่อมต่อ...",
  "CONNECTIVITY_STATUS_ALT_FATAL": "ไม่สามารถเชื่อมต่อได้",
  "CONNECTIVITY_STATUS_ALT_RECONNECTING": "เครือข่ายขัดข้อง กำลังเชื่อมต่อใหม่...",
  "CONNECTIVITY_STATUS_ALT_RENDER_ERROR": "แสดงข้อผิดพลาด โปรดตรวจสอบคอนโซลหรือติดต่อนักพัฒนาบอท",
  "CONNECTIVITY_STATUS_ALT_SLOW_CONNECTION": "ใช้เวลาเชื่อมต่อนานกว่าปกติ",
  "CONNECTIVITY_STATUS_ALT": "สถานะของการเชื่อมต่อ: $1",
  "COPY_BUTTON_TEXT": "คัดลอก",
  "COPY_BUTTON_COPIED_TEXT": "คัดลอกแล้ว",
  "FEEDBACK_FORM_SUBMIT_BUTTON_LABEL": "ส่ง",
  "FEEDBACK_FORM_CANCEL_BUTTON_LABEL": "ยกเลิก",
  "FEEDBACK_FORM_PLACEHOLDER": "ให้รายละเอียดมากที่สุดเท่าที่จะทำได้ แต่อย่าระบุข้อมูลส่วนตัวหรือข้อมูลที่ละเอียดอ่อน",
  "FEEDBACK_FORM_TITLE": "ให้ข้อมูลเกี่ยวกับประสบการณ์ของคุณ",
  "FILE_CONTENT_ALT": "'$1'",
  "FILE_CONTENT_DOWNLOADABLE_ALT": "ดาวน์โหลดไฟล์ '$1'",
  "FILE_CONTENT_DOWNLOADABLE_WITH_SIZE_ALT": "ดาวน์โหลดไฟล์ '$1' ขนาด $2",
  "FILE_CONTENT_WITH_SIZE_ALT": "'$1' ขนาด $2",
  "MARKDOWN_EXTERNAL_LINK_ALT": "เปิดในหน้าต่างใหม่; ภายนอก",
  "RECEIPT_CARD_TAX": "ภาษี",
  "RECEIPT_CARD_TOTAL": "ยอดรวม",
  "RECEIPT_CARD_VAT": "ภาษีมูลค่าเพิ่ม",
  "REFERENCE_LIST_HEADER_ONE": "การอ้างอิง $1 รายการ",
  "REFERENCE_LIST_HEADER_FEW": "การอ้างอิง $1 รายการ",
  "REFERENCE_LIST_HEADER_MANY": "การอ้างอิง$1รายการ",
  "REFERENCE_LIST_HEADER_OTHER": "การอ้างอิง$1",
  "REFERENCE_LIST_HEADER_TWO": "การอ้างอิง $1 รายการ",
  "SEND_BOX_ATTACHMENT_BAR_DELETE_BUTTON_ALT": "ลบสิ่งที่แนบ $1",
  "SEND_BOX_ATTACHMENT_BAR_DELETE_BUTTON_TOOLTIP": "ลบ",
  "SEND_BOX_ATTACHMENT_BAR_GENERIC_FILE_ALT": "ไฟล์",
  "SEND_BOX_ATTACHMENT_BAR_GENERIC_IMAGE_ALT": "รูปภาพ",
  "SEND_BOX_IS_EMPTY_TOOLTIP_ALT": "ไม่สามารถส่งข้อความที่ว่างเปล่า",
  "SPEECH_INPUT_LISTENING": "กำลังฟัง...",
  "SPEECH_INPUT_MICROPHONE_BUTTON_CLOSE_ALT": "ปิดไมโครโฟน",
  "SPEECH_INPUT_MICROPHONE_BUTTON_OPEN_ALT": "เปิดไมโครโฟน",
  "SPEECH_INPUT_STARTING": "กำลังเริ่ม...",
  "SUGGESTED_ACTIONS_FLIPPER_NEXT_ALT": "ถัดไป",
  "SUGGESTED_ACTIONS_FLIPPER_PREVIOUS_ALT": "ก่อนหน้า",
  "SUGGESTED_ACTIONS_LABEL_ALT": "การดำเนินการที่แนะนำ",
  "TEXT_INPUT_ALT": "กล่องป้อนข้อความ",
  "TEXT_INPUT_PLACEHOLDER": "พิมพ์ข้อความของคุณ",
  "TEXT_INPUT_SPEECH_IDLE_PLACEHOLDER": "เริ่มพูด...",
  "TEXT_INPUT_SPEECH_LISTENING_PLACEHOLDER": "กำลังฟัง...",
  "TEXT_INPUT_SPEECH_PROCESSING_PLACEHOLDER": "กำลังดำเนินการ...",
  "TEXT_INPUT_SPEECH_BOT_SPEAKING_PLACEHOLDER": "พูดเพื่อขัดจังหวะ...",
  "TEXT_INPUT_SEND_BUTTON_ALT": "ส่ง",
  "TEXT_INPUT_SPEAK_BUTTON_ALT": "พูด",
  "TEXT_INPUT_UPLOAD_BUTTON_ALT": "อัปโหลดไฟล์",
  "TEXT_INPUT_TELEPHONE_KEYPAD_BUTTON_ALT": "ปุ่มกดโทรศัพท์",
  "TEXT_INPUT_DROP_ZONE": "วางไฟล์",
  "TEXT_INPUT_LENGTH_EXCEEDED_ALT": "ข้อความมีความยาวเกินที่จำกัด",
  "TELEPHONE_KEYPAD_INPUT_MESSAGE": "รองรับอินพุตที่เป็นเลขหลักเดียวเท่านั้น",
  "TEXT_INPUT_ATTACHMENTS_FEW": "สิ่งที่แนบ $1",
  "TEXT_INPUT_ATTACHMENTS_MANY": "สิ่งที่แนบ $1",
  "TEXT_INPUT_ATTACHMENTS_ONE": "สิ่งที่แนบ 1 รายการ",
  "TEXT_INPUT_ATTACHMENTS_OTHER": "สิ่งที่แนบ $1",
  "TEXT_INPUT_ATTACHMENTS_TWO": "สิ่งที่แนบ $1",
  "TOAST_ACCORDION_FEW": "$1 การแจ้งเตือน: คลิกที่นี่เพื่อดูรายละเอียด",
  "TOAST_ACCORDION_MANY": "$1 การแจ้งเตือน: คลิกที่นี่เพื่อดูรายละเอียด",
  "TOAST_ACCORDION_OTHER": "$1 การแจ้งเตือน: คลิกที่นี่เพื่อดูรายละเอียด",
  "TOAST_ACCORDION_TWO": "$1 การแจ้งเตือน: คลิกที่นี่เพื่อดูรายละเอียด",
  "TOAST_ALT_ERROR": "ผิดพลาด",
  "TOAST_ALT_INFO": "ข้อมูล",
  "TOAST_ALT_SUCCESS": "สำเร็จ",
  "TOAST_ALT_WARN": "คำเตือน",
  "TOAST_DISMISS_BUTTON": "ปิดการเตือน",
  "TOAST_TITLE_ALT": "การแจ้งเตือน",
  "TRANSCRIPT_ARIA_LABEL_ALT": "ประวัติการแชท กดแป้นลูกศรเพื่อนำทาง",
  "TRANSCRIPT_ARIA_ROLE_ALT": "ประวัติการแชท",
  "TRANSCRIPT_LIVE_REGION_INTERACTIVE_LABEL_ALT": "ข้อความเป็นแบบโต้ตอบ กดแป้น Shift Tab 2 ถึง 3 ครั้งเพื่อสลับไปที่ประวัติการแชท จากนั้นคลิกที่ข้อความเพื่อโต้ตอบ",
  "TRANSCRIPT_LIVE_REGION_INTERACTIVE_WITH_LINKS_LABEL_ALT": "มีลิงก์อย่างน้อยหนึ่งลิงก์ในข้อความ กดแป้น Shift Tab 2 ถึง 3 ครั้งเพื่อสลับไปที่ประวัติการแชท จากนั้นคลิกที่ข้อความเพื่อโต้ตอบ",
  "TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_LABEL_ALT": "ข้อความมีการดำเนินการที่แนะนำ กด Shift Tab 2 ถึง 3 ครั้งเพื่อเลือก",
  "TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_WITH_ACCESS_KEY_LABEL_ALT": "ข้อความมีการดำเนินการที่แนะนำ กด $1 เพื่อเลือก",
  "TRANSCRIPT_LIVE_REGION_SEND_FAILED_ALT": "ไม่สามารถส่งข้อความได้",
  "TRANSCRIPT_LIVE_REGION_NEW_MESSAGES_ALT": "มีข้อความใหม่ กด $1 เพื่อโฟกัสที่ปุ่ม \"$2\"",
  "TRANSCRIPT_MORE_MESSAGES": "ข้อความเพิ่มเติม",
  "TRANSCRIPT_NEW_MESSAGES": "ข้อความใหม่",
  "TRANSCRIPT_TERMINATOR_TEXT": "สิ้นสุดประวัติการแชท",
  "TYPING_INDICATOR_ALT": "แสดงตัวแสดงการพิมพ์",
  "TYPING_INDICATOR_SINGLE_TEXT": "$1 กำลังพิมพ์",
  "TYPING_INDICATOR_MULTIPLE_TEXT": "$1 และคนอื่นๆ กำลังพิมพ์",
  "VIEW_CODE_BUTTON_TEXT": "โค้ด",
  "VOTE_COMPLETE_ALT": "บันทึกข้อคิดเห็นแล้ว",
  "VOTE_COMPLETE_ALT.comment": "ใช้สำหรับโปรแกรมอ่านหน้าจอ ป้ายชื่อของปุ่มที่มีไอคอนชูนิ้วโป้ง/คว่ำนิ้วโป้ง ป้ายชื่อจะใช้เมื่อบันทึกข้อคิดเห็นแล้ว",
  "VOTE_DISLIKE_ALT": "ไม่ถูกใจ",
  "VOTE_LIKE_ALT": "ถูกใจ"
}